import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { normalizeAppAppearanceId } from '../theme/appAppearance';
import { parseHoneycombColorMaps } from '../theme/honeycombCloudColors';

const COLLECTION = 'userUiPrefs';

function prefsDocRef(uid) {
  return doc(db, COLLECTION, uid);
}

export function parseCloudAppearance(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const obj = raw;
  if (typeof obj.appearance !== 'string' || !obj.appearance.trim()) return null;
  const appearanceUpdatedAt =
    typeof obj.appearanceUpdatedAt === 'number' &&
    Number.isFinite(obj.appearanceUpdatedAt)
      ? obj.appearanceUpdatedAt
      : 0;
  return {
    appearance: obj.appearance.trim(),
    appearanceUpdatedAt,
    honeycombColors: parseHoneycombColorMaps(obj.honeycombColors),
    honeycombColorsUpdatedAt:
      typeof obj.honeycombColorsUpdatedAt === 'number' &&
      Number.isFinite(obj.honeycombColorsUpdatedAt)
        ? obj.honeycombColorsUpdatedAt
        : 0,
  };
}

export async function saveUserUiAppearance(
  uid,
  appearance,
  appearanceUpdatedAt = Date.now()
) {
  await setDoc(
    prefsDocRef(uid),
    {
      appearance,
      appearanceUpdatedAt,
    },
    { merge: true }
  );
}

/**
 * Live-Sync des gemeinsamen Designs (Task / Mobile Task / Scanner / Navigator / Mail).
 * Fehlt das Feld → lokale Appearance hochladen.
 */
export function subscribeUserUiAppearance(uid, _localAppearance, onPrefs) {
  return onSnapshot(
    prefsDocRef(uid),
    (snap) => {
      const parsed = snap.exists()
        ? parseCloudAppearance(snap.data())
        : null;
      if (!parsed) {
        /* Kein Auto-Write: Design nur bei aktiver Änderung speichern. */
        return;
      }
      onPrefs(parsed);
    },
    () => {
      /* offline / permission — lokal bleiben */
    }
  );
}

export function subscribeHoneycombColors(uid, onMaps) {
  return onSnapshot(
    prefsDocRef(uid),
    (snap) => {
      if (!snap.exists()) return;
      onMaps(parseHoneycombColorMaps(snap.data()?.honeycombColors));
    },
    () => {
      /* offline */
    }
  );
}

/** Cloud-ID → Mail-Appearance (unbekannte IDs → null). */
export function asAppAppearanceId(raw) {
  if (raw === 'curriculum-dark') return 'curriculum';
  return normalizeAppAppearanceId(raw);
}
